// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ccZv","toggle":"styles_toggle__S3eQo","preview":"styles_preview__D5LSE"};